import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { programClient } from '../client/programClient';


export const useStepEntryCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createStepEntry = useMutation({
    mutationKey: [cacheKeys.createStepEntry],
    mutationFn: programClient.createStepEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getEnrollments],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getEnrollment],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const updateStepEntry = useMutation({
    mutationKey: ['updateStepEntry'],
    mutationFn: programClient.updateStepEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getEnrollments],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getEnrollment],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createStepEntry,
    updateStepEntry,
  };
};
